/* eslint-disable sonarjs/cognitive-complexity */
// https://github.com/codeandtheory/remi-pdf/blob/develop/src/services/footnotes/footnotes.service.ts
import { createElement } from "react";

const SELF_CLOSE_TAGS = ["br"];

export const reactJsonToJsx = ({ type, props, children } = {}) => {
  if (!type) {
    return null;
  }

  if (SELF_CLOSE_TAGS.includes(type)) {
    return (
      <>
        <br {...props} />
        {renderChildren(children)}
      </>
    );
  }

  const key = getKey(children);

  return createElement(type, { ...props, key }, renderChildren(children));
};

const renderChildren = (children) => {
  switch (typeof children) {
    case "string":
    case "number":
      return children;
    case "object":
      if (Array.isArray(children)) {
        return <>{children.map(reactJsonToJsx)}</>;
      }
      return reactJsonToJsx(children);
    default:
      return null;
  }
};

const getKey = (children) => {
  switch (typeof children) {
    case "string":
    case "number":
      return `${children}`;
    case "object":
      return `${JSON.stringify(children)}`;
    default:
      return null;
  }
};
